/**
 * Announcement pop-up (Oct 2026): a live announcement with the Pop-up channel shows once in a dialog when the
 * person opens the hub (any page). "Got it" closes it for good (dismiss key `annpop:<id>`, separate from Home's
 * "Got it", so it stays on Home when that channel is on too). One at a time, newest first.
 */
import { useState } from 'react';
import { announcementPopupKey } from '@daaily/shared';
import { Modal } from '../components/Modal';
import { useProfile } from '../profile/ProfileProvider';
import { callDismissAnnouncement } from './callables';
import { AnnouncementBody, useMyAnnouncements } from './AnnouncementView';

export function AnnouncementPopup() {
  const { state } = useProfile();
  const list = useMyAnnouncements();
  const [closed, setClosed] = useState<Record<string, boolean>>({});
  if (state.status !== 'ready' || !list) return null;
  const dismissed = new Set(state.user.dismissedAnnouncements ?? []);
  const next = list.find((a) => a.channels.popup && !dismissed.has(announcementPopupKey(a.id)) && !closed[a.id]);
  if (!next) return null;
  const close = () => {
    setClosed((c) => ({ ...c, [next.id]: true }));
    void callDismissAnnouncement({ key: announcementPopupKey(next.id) }).catch(() => undefined);
  };
  return (
    <Modal open onClose={close} title={next.rendered.title} widthClass="max-w-lg">
      <div className="space-y-4">
        <AnnouncementBody rendered={next.rendered} linkUrl={next.linkUrl} linkLabel={next.linkLabel} />
        <p className="text-xs text-fg-faint">From {next.authorDisplayName}</p>
        <div className="flex justify-end">
          <button type="button" className="btn-primary" onClick={close}>Got it</button>
        </div>
      </div>
    </Modal>
  );
}
